import React, { useEffect, useState } from "react";
import "./workflow-todo.component.scoped.scss";
import { Box } from "@material-ui/core";
import WorkflowAddTodo from "../workflow-add-todo/workflow-add-todo.component";
import TasksRowComponent from "../../../../../../../tasks/components/tasks-row/tasks-row.component";

interface WorkflowTodoProps {
  answer: number;
  todoList: any[];
  workflowLoading: boolean;
  caseQuestionId: number;
  question: string;
  user: any;
  refresh: (itemKey: string) => void;
  onDeleteTodoList: (index: number) => void;
  onUpdateTodoList: (todo: any) => void;
}

const WorkflowTodo = (props: WorkflowTodoProps) => {
  const {
    answer,
    todoList,
    workflowLoading,
    caseQuestionId,
    question,
    user,
    refresh,
    onUpdateTodoList,
  } = props;

  const [data, setData] = useState(todoList);

  useEffect(() => {
    setData(todoList);
  }, [todoList]);

  return (
    <Box className="todo-wrapper px-5 py-3">
      <Box className="d-flex flex-column w-100">
        <Box className="mb-4">
          {answer === null && user.role !== "auditor" ? (
            <WorkflowAddTodo
              question={question}
              caseQuestionId={caseQuestionId}
              loading={workflowLoading}
              updateTodoList={(newTodo: string) => {
                onUpdateTodoList(newTodo);
              }}
            />
          ) : null}
        </Box>

        <Box id="todo__list__data">
          {data.map((todo: any, index: any) => {
            return (
              <TasksRowComponent
                refresh={refresh}
                key={index}
                data={todo}
                user={user}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default WorkflowTodo;
